const TeamMemberCard = ({ member, onOpenDialog }) => {
  return (
    <div className="bg-[#674DA2] bg-opacity-80 rounded-xl shadow-lg p-6 text-center text-white transform hover:scale-105 transition-transform duration-300 ease-in-out">
      <img
        src={member.imageSrc}
        alt={member.name}
        className="w-40 h-40 md:w-56 md:h-56 mx-auto rounded-full object-cover mb-4 border-4 border-white shadow-md"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src =
            "https://placehold.co/160x160/E2E8F0/4A5568?text=Person";
        }}
      />
      <h3 className="text-xl font-semibold mb-1">{member.name}</h3>
      <p className="text-sm text-gray-300 mb-4">{member.title}</p>
      <button
        onClick={() => onOpenDialog(member)}
        className="bg-[#F3DA6D] text-[#674DA2] font-semibold py-2 px-6 rounded-lg  transition-colors duration-300 shadow-md focus:outline-none   focus:ring-opacity-50 hover:bg-yellow-400"
      >
        Толығырақ
      </button>
    </div>
  );
};
export default TeamMemberCard;
